import i18next from 'i18next';
import { StringUtils } from '../utils/string';

const formatter = i18next?.services?.formatter;

formatter?.add('lowercase', (value, lng, options) => {
  return (value || '').toLowerCase();
});

formatter?.add('firstCap', (value, lng, options) => {
  return StringUtils.toFirstCap(value || '');
});

formatter?.add('firstCapEachWord', (value, lng, options) => {
  return StringUtils.toFirstCapEachWord(value || '');
});

// @ts-ignore
formatter?.add('autoSpace', (value = '', lng, options) => {
  if (value.length > 0) {
    return value + ' ';
  } else return '';
});
